module.exports = __webpack_public_path__ + "img/nocktown-card-bg.24032352.png";